import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

import { apiContainer } from '@bvi/dashboard/shared/api/base-rtk-api';

/**
 * @param options - Optional parameter representing the preloaded state of the store.
 * @returns The created Redux store.
 */
export const createStore = (
  options?: ConfigureStoreOptions['preloadedState'],
) => {
  const { reducerPath, reducer, middleware } = apiContainer;
  return configureStore({
    reducer: {
      [reducerPath]: reducer,
    },
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware(),
      middleware,
    ],
    enhancers: [Sentry.createReduxEnhancer()],
    ...options,
  });
};
